export var FilterCssClass;
(function (FilterCssClass) {
    FilterCssClass["Base"] = "iress-filter";
    FilterCssClass["MultiSelect"] = "iress-filter--multi-select";
    FilterCssClass["Searchable"] = "iress-filter--searchable";
    FilterCssClass["Activator"] = "iress-filter__activator";
    FilterCssClass["Menu"] = "iress-filter__menu";
    FilterCssClass["MenuItem"] = "iress-filter__menu-item";
    FilterCssClass["Utils"] = "iress-filter__utils";
    FilterCssClass["Search"] = "iress-filter__search";
    FilterCssClass["Reset"] = "iress-filter__reset";
    FilterCssClass["NoResults"] = "iress-filter__no-results";
})(FilterCssClass || (FilterCssClass = {}));
//# sourceMappingURL=filter.types.js.map